<template>
  <router-view />
</template>

<script>
export default {
  name: 'KernelOrdersWrapper',
};
</script>
